<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑商品
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
		</div>

		<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
			<div class="add2-content">
				<div class="left">
					<div class="tit">
						<span class="name">基础设置</span>
					</div>
					<el-form-item label="商品分类" v-if="categoryData.length > 0">
						<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds"
							:options="categoryData[0].children" :show-all-levels="true"
							:props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
					</el-form-item>
					<el-form-item label="品牌名:" class=" mandatory" prop="brand_name">
						<el-autocomplete class="inline-input" v-model="editParams.brand_name" value-key="name"
							:fetch-suggestions="querySearch" placeholder="请输入内容" size='mini' @select="handleSelect">
						</el-autocomplete>
					</el-form-item>
					<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'>
					</storeSelect>

					<el-form-item label="适用品种" prop="category_of">
						<el-radio-group v-model="editParams.applyType">
							<el-radio label="0">通用</el-radio>
							<el-radio label="1">猫用</el-radio>
							<el-radio label="2">犬用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否复购">
						<el-radio-group v-model="editParams.buy_back">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="系列名称" prop="series_name">
						<el-autocomplete class="inline-input" v-model="editParams.series_name"
							:fetch-suggestions="querySearchseries_name" placeholder="请输入内容" size='mini'
							@select="handleSelectseries_name">
							<template slot-scope="{ item }">
								<div class="name">{{ item.name}}</div>
							</template>
						</el-autocomplete>

					</el-form-item>
					<el-form-item label="最小库存预警 " prop="min_stock">
						<el-input v-model.number="editParams.stock_alert" size="mini" style="width: 100px;"
							placeholder="请输入库存下限"></el-input>
					</el-form-item>
					<el-form-item label="商品描述" prop="desc">
						<el-input v-model="editParams.desc" size="mini" style="width: 200px;" placeholder="请输入商品描述">
						</el-input>
					</el-form-item>

					<el-form-item label="商品备注 :" prop="remark">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" style="width: 220px;"
							v-model="editParams.remark"></el-input>
					</el-form-item>
				</div>
				<div class="right info" ref='skucontent'>
					<div class="tit">
						<span class="name">附加属性</span>
					</div>
					<span class="m-l-10 color-969799 f-12">请谨慎添加/编辑/删除规格,此规格的添加,将会在小程序,商品库,打印条码处共同展示!</span>
					<span class="m-l-10 color-969799 f-12">若进行删除,重新编辑,请尽可能的通知到与商品相关的人员</span>
					<div class="skucontent">

						<!-- 编辑 添加  -->
						<div class="skuitem" v-for="(skuitem,skuindex) in editParams.skuList" :key='skuindex'>
							<div style="text-align: center;font-size: 16px;color:#FF0000;margin-top: 10px;">
								商品{{skuindex+1}}</div>
							<el-form-item label-width="110px" v-for="(skuinfo,index) in skuitem.skuInfo" :key='index'
								:label="toName(skuinfo.name)"
								:class="{'formitemlable':skuinfo.name=='price_p','formitemsku':true}" style="">

								<el-input v-model="skuinfo.value" size="mini" :disabled='skuitem.status==0'
									style="width: 150px" :placeholder="'请输入'+skuinfo.name"></el-input>
								<!-- v-if="skuitem.skuInfo.length!=1&&!params.goodsId&&skuindex==0" -->
								<el-button v-if="skuitem.skuInfo.length!=1&&skuindex==0" type="text"
									style="margin-left: 10px;" @click='deleteSkuinfo(skuitem,index)'>删除</el-button>
							</el-form-item>
							<div style="text-align: center;font-size: 16px;color:#FF0000;margin-top: 10px;">
								<template v-if="skuindex==0">
									<el-popover popper-class='popover' placement="bottom" width="160"
										v-model="skuDailog">
										<div>规格名称</div>
										<el-input v-model="skuName" size="mini" style="width: 160px;margin-top: 10px"
											placeholder="请输入规格名称"></el-input>
										<div style="text-align: right; margin-top: 10px">
											<el-button size="mini" type="text" @click="skuDailog = false">取消</el-button>
											<el-button type="primary" size="mini" @click='addSku(skuitem,skuindex)'>确定
											</el-button>
										</div>
										<el-button slot="reference" size="mini" type="warning"
											style="margin-left: 10px;">添加规格</el-button>
									</el-popover>
								</template>

								<el-button v-if="skuitem.skuId&&skuitem.status==1"
									style="text-align: center;margin-left: 10px;" type="warning" size="mini"
									@click='toVoid(skuitem,skuindex)'>作废</el-button>
								<el-button v-if="skuitem.skuId&&skuitem.status==0"
									style="text-align: center;margin-left: 10px;" type="danger" size="mini"
									@click='toVoid(skuitem,skuindex)'>取消作废</el-button>
								<el-button v-if="editParams.skuList.length!=1&&!skuitem.skuId"
									style="text-align: center;" type="danger" size="mini"
									@click='deleted(skuitem,skuindex)'>删除 </el-button>
								<el-button style="text-align: center;margin-left: 10px;" type="primary" size="mini"
									@click='copy(skuitem,skuindex)'>复制</el-button>
							</div>
							<div class="totaltitle">
								{{editParams.brand_name}} {{editParams.series_name}} <span
									v-if="editParams.applyType=='0'">通用</span>
								<span v-if="editParams.applyType=='1'">猫用</span>
								<span v-if="editParams.applyType=='2'">狗用</span>
								<!-- <template v-if="editParams.simple_title">({{params.simple_title}})</template> -->
								<div style="margin-top: 4px;color: #999;">
									<span v-for="(skuinfo,index) in skuitem.skuInfo" :key='index'> <span
											v-if="skuinfo.value.length>0&&skuinfo.name !='price_p' &&skuinfo.name !='price_o' &&skuinfo.name !='price_c'">
											{{skuinfo.value}}</span></span>
								</div>
							</div>
							<div style="margin-top: 10px;">
								<el-form-item label="包装方式" label-width="80px">
									<div v-for="(pakage,num) in skuitem.packingInfo" :key='num'>
										<span v-if="num==0">
											<el-select v-model="pakage.bigPacking" style="width: 60px;" size="small"
												placeholder="请选择" @change="(val)=>changepackage(val,num,skuindex)">
												<el-option v-for="item in pakageData" :key="item.name"
													:label="item.name" :value="item.name"></el-option>
											</el-select>
											<!-- <el-input v-model="pakage.bigPacking" size="small" style="width: 50px;" @change="(num,skuindex)=>changepackage(num,skuindex)"></el-input> -->
											=
										</span>

										<span v-if="pakage.bigPacking" :style="{'margin-left':num>0?'75px':0}">
											1 {{pakage.bigPacking}}/
										</span>

										<el-input v-if="pakage.bigPacking" size="small"
											style="width: 70px;margin-right: 5px;" v-model="pakage.smallPackingCount">
										</el-input>
										<!-- <el-input v-if="pakage.bigPacking" v-model="pakage.smallPacking" size="small" style="width: 50px;" @change="(num,skuindex)=>changepackage(num,skuindex)"></el-input> -->
										<el-select v-if="pakage.bigPacking" v-model="pakage.smallPacking"
											style="width: 60px;" size="small" placeholder="请选择"
											@change="(val)=>changepackage(val,num,skuindex)">
											<el-option v-for="item in pakageData" :key="item.name" :label="item.name"
												:value="item.name"></el-option>
										</el-select>
										<el-button v-if="num+1==skuitem.packingInfo.length" type="text"
											style="margin-left: 10px;" @click='addpakage(num,skuindex)'>新建</el-button>
										<el-button v-if="num>0" type="text" style="margin-left: 10px;"
											@click='deletepakage(num,skuindex)'>删除</el-button>
									</div>
								</el-form-item>
							</div>
							<div>
								<el-form-item label="条码" label-width="90px">
									
										<el-input size="small" style="width: 200px;margin-left: 5px;"
											v-model="skuitem.barcode" placeholder="请输入条码"></el-input>
											<el-button  size="mini" type="warning" style="margin-left: 10px;"
											@click='CreateBarCode(skuitem)'>生成条码</el-button>
								</el-form-item>
							</div>
							<div>
								<el-form-item label="销售方式" label-width="100px">
									<div v-for="(pakage,num) in skuitem.packingPrice" :key='num'>
										1 {{pakage.name}} = 标准价
										<el-input size="small" style="width: 80px;margin-left: 5px;"
											v-model="pakage.pprice" placeholder="请输入销售价"></el-input>
											会员价
											<el-input size="small" style="width: 80px;margin-left: 5px;"
											v-model="pakage.mprice" placeholder="请输入会员销售价" ></el-input>
									</div>
								</el-form-item>
							</div>
							<div v-if="id != undefined">
								<el-form-item label="状态" label-width="70px">
									<el-radio-group v-model="skuitem.status">
										<el-radio :label="1">启用</el-radio>
										<el-radio :label="0">暂停</el-radio>
										<el-radio :label="-1">作废</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
						
						</div>

					</div>

				</div>
			</div>


		</el-form>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="warning" size="small" :loading="loading" @click='addGoods'>确定</el-button>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		// VUE_APP_Url_baseData
		makeCode,
		getProductTypeList, // api.get(`${baseURL2}api/dict/ProductType/tree`
		getProductTypeDl, // pi.get(`${baseURL2}api/dict/ProductType/codemodel`
		getBrandInfoList, // api.post(`${baseURL2}api/dict/BrandInfo/list`
		getProductGoodsDl, // api.get(`${baseURL2}api/product/goods/simple`
		getSeriesList, // api.post(`${baseURL2}api/GoodsOtherInfo/SeriesList`
		getProductPakageList, // api.post(`${baseURL2}api/dict/ProductType/list`
		setProductGoods // api.post(`${baseURL2}api/product/goods/update`
	} from '../../../api/productApi.js'
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: {
			storeSelect,
		},
		data() {
			return {
				id: this.$route.query.id,
				rules: {
					brand_name: [{
						required: true,
						message: '不能为空',
						trigger: 'change'
					}],

				},
				editParams: {
					"goodsId": "",
					"brand_name": "",
					"series_name": "",
					"applyType": '0',
					"title": "",
					"buy_back": 1,
					"category_info": {
						"_id": "",
						"name": "",
						"code": ""
					},
					"category_list": [{
						"_id": "",
						"name": "",
						"code": ""
					}],
					"stock_alert": 1,
					"shop_info": [],
					"desc": "",
					"remark": "",
					"skuList": [{
						"skuId": "",
						skuInfo: [{
								value: '',
								name: '适用年龄段'
							},
							{
								value: '',
								name: '宠物类型'
							},
							{
								value: '',
								name: '功效/功能'
							},
							{
								value: '',
								name: '用法'
							},
							{
								value: '',
								name: '形状'
							}, {
								value: '',
								name: '味道'
							},
							{
								value: '',
								name: '材质'
							},
							{
								value: '',
								name: '款式/颜色/花纹'
							},
							{
								value: '',
								name: '时效'
							},
							{
								value: '',
								name: '尺寸/重量/体积'
							},
							{
								value: '',
								name: '包装方式'
							},
							{
								value: '',
								name: '规格'
							},

						],
						"status": 1,
						"barcode":'',
						"packingInfo": [{
							"bigPacking": "",
							"smallPacking": "",
							"smallPackingCount": 0
						}],
						"packingPrice": []
					}],
				},
				storeIds: [],
				showShops: false,
				productTypeIds: [],
				categoryData: [],
				brandList: [],
				skuDailog: false,
				skuName: '',
				pakageData: [],
				loading: false,
			}
		},
		methods: {
			CreateBarCode(skuitem){
				makeCode().then(res => {
					if(res.code==0){
						skuitem.barcode=res.data
					}
				})
			},
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/chanpin/goods'
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			getProductGoodsDl(id) {
				this.showShops = false;
				getProductGoodsDl({
					id,
				}).then(res => {
					if (res.code == 0) {
						console.log('详情', res.data)
						this.editParams = res.data;

						this.productTypeIds = [];
						res.data.category_list.forEach((item, index) => {
							if (index > 0) {
								this.productTypeIds.push(item._id)
							}
						})
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;

					}
				})
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			handleSelect(val) {
				this.editParams.brand_name = val.name;
			},
			querySearch(queryString, cb) {
				this.getBradList(queryString)
				this.timeout = setTimeout(() => {
					let goodsData = this.brandList;
					cb(goodsData);
				}, 1000)

			},
			getBradList(keyword) {
				getBrandInfoList({
					keyword,
					pageIndex: 0,
					pageSize: 0
				}).then(res => {
					this.brandList = res.data.data;
				})
			},
			getProductTypeList() {
				getProductTypeList({
					category: '商品'
				}).then(res => {
					if (res.code == 0) {
						console.log('商品', res.data)
						this.categoryData = res.data;
					}
				})
			},
			getProductPakageList() {
				getProductPakageList({
					category: '包装单位'
				}).then(res => {
					if (res.code == 0) {
						this.pakageData = res.data.data;
					}
				})
			},
			handleSelectseries_name(val) {
				this.editParams.series_name = val.name
			},
			querySearchseries_name(queryString, cb) {
				this.getSeriesList(queryString)
				this.timeout = setTimeout(() => {
					let goodsData = this.seriesList;
					cb(goodsData);
				}, 1000)
			},
			getSeriesList(queryString) {
				getSeriesList({
					keyword: queryString
				}).then(res => {
					this.seriesList = res.data
				})
			},
			getStores(data) {
				this.editParams.shop_info = data;
			},
			deleteSkuinfo(skuitem, skuinfoindex) {
				this.editParams.skuList.forEach(item => {
					item.skuInfo.splice(skuinfoindex, 1)
				})
				console.log(skuitem);
			},
			addSku(skuitem, index) {
				console.log(index, 'addSku')
				if (!this.skuName) {
					this.$message.error('请输入规格名称');
				} else {
					this.skuDailog = false;
					this.editParams.skuList.forEach(item => {
						item.skuInfo.splice(item.skuInfo.length - 3, 0, {
							name: this.skuName,
							value: ''
						})
					})
				}
			},
			// 复制
			copy(skuitem, index) {
				console.log(index, 'copy')
				let skuitemdata = Object.assign({}, JSON.parse(JSON.stringify(skuitem)));
				skuitemdata.skuId = '';
				this.editParams.skuList.push(skuitemdata);
				this.$refs.skucontent.scrollLeft = this.editParams.skuList.length * 320;
			},
			toName(name) {
				if (name == 'price_p') {
					return '销售价'
				} else if (name == 'price_o') {
					return '划线价'
				} else if (name == 'price_c') {
					return '成本价'
				} else {
					return name
				}
			},
			//删除规格
			deleted(skuitem, index) {
				this.editParams.skuList.splice(index, 1)
			},
			//作废
			toVoid(skuitem, index) {
				console.log(index, 'tovoid')
				if (skuitem.status == 1) {
					skuitem.status = 0;
				} else {
					skuitem.status = 1;
				}
				console.log(skuitem.status)
				// skuitem.sta
			},
			addpakage(num, skuindex) {
				if (!this.editParams.skuList[skuindex].packingInfo[num].bigPacking) {
					this.$message.error('请输入包装名称');
				} else if (this.editParams.skuList[skuindex].packingInfo[num].smallPacking == '') {
					this.$message.error('请输入包装名称');
				} else {
					this.editParams.skuList[skuindex].packingInfo.push({
						"bigPacking": this.editParams.skuList[skuindex].packingInfo[num].smallPacking,
						"smallPacking": "",
						"smallPackingCount": 0,
					})
				}

			},
			deletepakage(num, skuindex) {
				var packingInfoData = [];
				this.editParams.skuList[skuindex].packingInfo.splice(num, 1)
				this.editParams.skuList[skuindex].packingInfo.forEach(item => {
					packingInfoData.push(item.bigPacking)
					packingInfoData.push(item.smallPacking)
				})
				this.editParams.skuList[skuindex].packingPrice = [];
				new Set(packingInfoData).forEach(item => {
					if (item) {
						this.editParams.skuList[skuindex].packingPrice.push({
							"name": item,
							"pprice": 0,
							"mprice": 0,
							"cprice": 0,
							"oprice": 0,
							"barcode": ""
						})
					}

				})
			},
			changepackage(val, num, skuindex) {
				var packingInfoData = [];
				this.editParams.skuList[skuindex].packingInfo.forEach(item => {
					packingInfoData.push(item.bigPacking)
					packingInfoData.push(item.smallPacking)
				})
				this.editParams.skuList[skuindex].packingPrice = [];
				new Set(packingInfoData).forEach(item => {
					if (item) {
						this.editParams.skuList[skuindex].packingPrice.push({
							"name": item,
							"pprice": 0,
							"mprice": 0,
							"cprice": 0,
							"oprice": 0,
							"barcode": ""
						})
					}

				})
				console.log(num, skuindex, new Set(packingInfoData))
			},
			addGoods() {
				this.loading = true;
				let name;
				if (this.editParams.applyType == '0') {
					name = '通用'
					this.editParams.title = `${this.editParams.brand_name} ${this.editParams.series_name}`
				} else if (this.editParams.applyType == '1') {
					name = '猫用'
					this.editParams.title = `${this.editParams.brand_name} ${this.editParams.series_name}  ${name}`
				} else {
					name = '狗用'
					this.editParams.title = `${this.editParams.brand_name} ${this.editParams.series_name}  ${name}`
				}
				
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setProductGoods(this.editParams).then(res => {
							if (res.code == 0) {
								this.loading = false;
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.push({
									path: '/chanpin/goods'
								})
							}
						})
					} else {

						return false;
					}
				});

			}
		},
		created() {
			this.getProductPakageList();
			this.getProductTypeList();
			if (this.$route.query.id) {
				this.getProductGoodsDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			background-color: #f5f5f5;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.formitem {
			margin-bottom: 0px;
		}

		.add2-content {
			display: flex;
			justify-content: flex-start;

			.left {
				width: 30%;
				border-right: 1px dotted #666;

				.baseinfo {
					border-bottom: 1px dotted #666;
				}
			}

			.right {
				width: 70%;
				overflow-y: scroll;
				padding: 10px;
			}



		}

		.formitemsku {
			margin-bottom: 0px;
			// width: 300px;
		}

		.formitemlable {
			.el-form-item__label {
				color: red;
			}
		}

		.mandatory {
			margin-bottom: 10px;
		}

		.skucontent {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-top: 10px;

			.totaltitle {
				color: #666;
				padding: 10px 20px;
				font-size: 14px;
			}

			.skuitem {
				width: 420px;
				border: 1px dotted #666;
				// borde: 1px dotted #999;

			}

		}


		.footer {
			background-color: #f5f5f5;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
